<div
  class="d-flex align-items-center justify-content-center py-3 px-5"
  [ngClass]="showMore ? 'h-100' : ''"
>
  <div
    class="w-100 sortable-list d-flex flex-wrap gap-4"
    [ngClass]="showMore ? 'justify-content-center' : 'justify-content-center'"
    (dragover)="onDragOver($event)"
    (dragenter)="onDragEnter($event)"
  >
    <ng-container>
      <div
        class="item px-4 py-1"
        draggable="false"
        (dragstart)="onDragStart($event)"
        (dragend)="onDragEnd($event)"
        style="
          background-color: rgb(255, 255, 255);
          border-radius: 6px;
          border: 1px solid rgb(180, 180, 180);
          width: clamp(350px, calc(30% - 3rem), 30%);
          min-width: 350px;
        "
      >
        <div
          class="d-flex flex-row justify-content-between align-self-center py-1"
        >
          <div class="fs-5 fw-light text-nowrap overflow-hidden text-truncate">
            {{ "Resumen de estados de transmisión de las unidades" }}
          </div>
          <div class="d-flex flex-row gap-2">
            <div
              style="color: green; animation: 3s ease 0s infinite beat"
              class="d-flex flex-row align-items-center gap-2"
            >
              <svg width="8" height="8" fill="currentColor" viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="8" />
              </svg>
              <samp
                class="text-uppercase text-nowrap overflow-hidden text-truncate"
                >Datos en vivo</samp
              >
            </div>
            <button
              pButton
              pRipple
              type="button"
              (click)="more()"
              [icon]="showMore ? 'pi pi-minus' : 'pi pi-plus'"
              class="p-button-sm p-button-rounded p-button-text"
              style="color: #6c757d"
            ></button>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between">
          <app-chart
            style="min-height: 172px"
            class="w-100 ratio ratio-16x9"
            [inLive]="true"
            [type]="'advancedPieChart'"
            [library]="'NGX-Charts'"
          ></app-chart>
          <div class="position-relative t-0 r-0">
            <div
              class="position-absolute top-0 end-0 d-flex justify-content-end"
              style="width: 200px"
            >
              <p-multiSelect
                [options]="units"
                [(ngModel)]="unitsToFilterGlobally"
                optionLabel="unitName"
                selectedItemsLabel="{0} items selected"
                defaultLabel="Buscar unidades..."
                class="w-100"
                [styleClass]="'w-100'"
                [showToggleAll]="false"
              >
                <ng-template let-item pTemplate="item">
                  <div class="" style="font-size: 0.8rem">
                    <div>
                      {{ item.unitName }}
                    </div>
                  </div>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!showMore">
      <div
        style="
          background-color: rgba(255, 255, 255, 0);
          width: clamp(350px, calc(30% - 3rem), 30%);
        "
      ></div>
      <div
        style="
          background-color: rgba(255, 255, 255, 0);
          width: clamp(350px, calc(30% - 3rem), 30%);
        "
      ></div>
    </ng-container>
    <ng-container *ngIf="showMore">
      <div
        class="item px-4 py-1"
        *ngFor="
          let unitTxStatus of unitTxStates$ | async;
          trackBy: trackByTxStatus
        "
        draggable="true"
        (dragstart)="onDragStart($event)"
        (dragend)="onDragEnd($event)"
        style="
          background-color: rgb(255, 255, 255);
          border-radius: 6px;
          border: 1px solid rgb(180, 180, 180);
          width: clamp(350px, calc(30% - 3rem), 30%);
        "
      >
        <div
          class="d-flex flex-row justify-content-between align-self-center py-1"
        >
          <div class="fs-5 fw-light text-nowrap overflow-hidden text-truncate">
            {{ unitTxStatus.transmissionStatusName }}
          </div>
          <div
            style="color: green; animation: 3s ease 0s infinite beat"
            class="d-flex flex-row align-items-center gap-2"
          >
            <svg width="8" height="8" fill="currentColor" viewBox="0 0 16 16">
              <circle cx="8" cy="8" r="8" />
            </svg>
            <samp
              class="text-uppercase text-nowrap overflow-hidden text-truncate"
              >Datos en vivo</samp
            >
          </div>
        </div>
        <div class="w-100 ratio ratio-16x9">
          <div class="d-flex flex-row justify-content-between">
            <app-chart
              class="w-50 ratio ratio-1x1"
              [id]="unitTxStatus.transmissionStatusId"
              [inLive]="true"
              [library]="unitTxStatus.library"
            ></app-chart>
            <div class="w-50 pt-2 d-flex flex-column gap-1">
              <!-- <div style="height: 1.5rem">Options</div> -->
              <!-- <p-dropdown
              styleClass="w-100"
              [options]="typeCharts"
              [(ngModel)]="unitTxStatus.library"
              optionValue="library"
              optionLabel="library"
            ></p-dropdown> -->
              <app-unit-list
                class="flex-fill"
                style="height: calc(100% - 1.75rem); display: block"
                [id]="unitTxStatus.transmissionStatusId"
                [inLive]="true"
                [filterBy]="unitsToFilterGlobally"
              ></app-unit-list>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
